import UserChatroom from "../../../components/Chatroomform";

const Chatroomform=()=>{
return(<>
    <UserChatroom title="Create Chat Profile" btn="Create" />
</>)

}

export default Chatroomform